const getValue = (object, property = 'value') => (object ? object[property] : null)

export default (form) => {
    const {
        title,
        target,
        unitOfMeasurement,
        weight,
        activePeriod,
        owner,
        initialValue,
        yearToDate,
        level,
        section,
        description,
        polarity,
        checkInFrequency,
        rangesOfPerformance,
        objectiveId,
        targetLibrary,
        profileUserId,
    } = form
    return {
        title: title,
        target: target,
        unit_of_measurement_id: getValue(unitOfMeasurement),
        weight: weight,
        period_id: getValue(activePeriod),
        user_id: getValue(owner),
        initial_value: initialValue || 0,
        year_to_date_id: getValue(yearToDate),
        frequency: checkInFrequency,
        level: getValue(level),
        section_id: getValue(section),
        description: description,
        polarity: getValue(polarity),
        objective_id: objectiveId,
        target_library: targetLibrary,
        profile_user_id: profileUserId,
        ranges: rangesOfPerformance.map((range) => {
            const { id, value, description } = range
            return {
                range_id: id,
                value,
                description,
            }
        }),
    }
}
